<template>
  <BaseElFormItem v-bind="$attrs">
    <template #label>
      <div class="inline-flex" style="gap: 8px">
        <p>{{ label }}</p>
        <slot name="description">
          <p class="description">{{ description }}</p>
        </slot>
      </div>
    </template>
    <slot />
  </BaseElFormItem>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'FormItemDescription',
  props: {
    label: String,
    description: String,
  },
  setup (props) {
    return {}
  },
})
</script>

<style lang="postcss" scoped>
.description {
  @apply text-gray-80 text-sm;
}
</style>
